import { Paper, Box, useTheme, Typography, TextField } from "@mui/material";
import { tokens } from "../../theme";
import ProductTable from "./card-estoques";
import { useState } from "react";
import dayjs from "dayjs";

const TextFieldOptions = {
    "& .MuiInputBase-input": { color: "#fff" },           // texto digitado
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "grey" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" },
    "& .MuiInputLabel-root.Mui-focused": { color: "#fff" }, // label focado
}

const AjustesEstoquesTable = ({ moveInventoryData = [] }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // Estados dos filtros
    const [filterId, setFilterId] = useState("");
    const [filterModel, setFilterModel] = useState("");
    const [filterMove, setFilterMove] = useState("");
    const [filterObs, setFilterObs] = useState("");
    const [filterDate, setFilterDate] = useState(""); // formato DD/MM/YYYY ou ISO

    if (moveInventoryData.length === 0) {
        return (
            <Box
                component={Paper}
                elevation={10}
                borderRadius={2}
                p={2}
                sx={{
                    backgroundColor: colors.pink[800],
                    height: "80dvh",
                    marginRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Typography fontSize={20}>Sem Movimentações até o Momento</Typography>
            </Box>
        );
    }

    // Aplica todos os filtros combinados
    const filteredProducts = moveInventoryData.filter((p) => {
        const matchId =
            !filterId || p.product_id.toString().includes(filterId.trim());
        const matchModel =
            !filterModel ||
            (p.model && p.model.toLowerCase().includes(filterModel.trim().toLowerCase()));
        const matchMove =
            !filterMove ||
            (p.type_move && p.type_move.toLowerCase().includes(filterMove.trim().toLowerCase()));
        const matchObs =
            !filterObs ||
            (p.observation &&
                p.observation.toLowerCase().includes(filterObs.trim().toLowerCase()));
        const matchDate =
            !filterDate ||
            (p.criados &&
                dayjs(p.criados).format("DD/MM/YYYY").includes(filterDate.trim()));

        return matchId && matchModel && matchMove && matchObs && matchDate;
    });

    return (
        <>
            {/* Filtros acima da tabela */}
            <Box sx={{ display: "inline-flex", gap: 1, mb: 1, flexWrap: "wrap", backgroundColor: colors.pink[800], p: 2, width: 'auto' }} component={Paper} elevation={6}>
                <TextField
                    label="ID Produto"
                    variant="outlined"
                    size="small"
                    value={filterId}
                    onChange={(e) => setFilterId(e.target.value)}
                    sx={TextFieldOptions}
                />
                <TextField
                    label="Modelo"
                    variant="outlined"
                    size="small"
                    value={filterModel}
                    onChange={(e) => setFilterModel(e.target.value)}
                    sx={TextFieldOptions}
                />
                <TextField
                    label="Movimento"
                    variant="outlined"
                    size="small"
                    value={filterMove}
                    onChange={(e) => setFilterMove(e.target.value)}
                    sx={TextFieldOptions}
                />
                <TextField
                    label="Observação"
                    variant="outlined"
                    size="small"
                    value={filterObs}
                    onChange={(e) => setFilterObs(e.target.value)}
                    sx={TextFieldOptions}
                />
                <TextField
                    label="Data (DD/MM/YYYY)"
                    variant="outlined"
                    size="small"
                    value={filterDate}
                    onChange={(e) => setFilterDate(e.target.value)}
                    sx={TextFieldOptions}
                />
            </Box>

            {/* Box da tabela */}
            <Box
                component={Paper}
                elevation={10}
                borderRadius={2}
                sx={{
                    backgroundColor: colors.pink[800],
                    height: "70dvh",
                    marginRight: "10px",
                    overflow: "auto",
                    p: 2,
                }}
            >
                <ProductTable products={filteredProducts} />
            </Box>
        </>
    );
};

export default AjustesEstoquesTable;
